import TablePage from './index.vue';

export default TablePage;
